'use client';

import { c as _c } from "react/compiler-runtime";
import ReactPlayerLoader from '@brightcove/react-player-loader';
import { useState } from 'react';
import { cn } from '@src/utils/tailwind';
export interface BrightcovePlayerProps {
  videoId: string;
  accountId?: string;
  playerId?: string;
  videoPlayerAspectRatio?: string;
  autoplay?: boolean;
  fluid?: boolean;
  isMuted?: boolean;
  width?: number;
}
const UnmuteIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="size-10 md:size-14 lg:size-20" width="81" height="82" viewBox="0 0 81 82" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.556641" width="81" height="81" rx="40.5" fill="white" /><path fillRule="evenodd" clipRule="evenodd" d="M51.538 45.8159V22.1102C51.538 21.2862 51.2619 20.5817 50.7099 19.9967C50.1578 19.4117 49.4615 19.1191 48.6211 19.1191C48.0443 19.1191 47.5252 19.2551 47.0638 19.527C46.6024 19.7989 46.0585 20.2233 45.4323 20.8L36.212 29.3529C36.0802 29.4683 35.9566 29.5259 35.8412 29.5259H35.2233L51.538 45.8159ZM60.956 63.6138C61.4669 63.6138 61.8953 63.4325 62.2414 63.0699C62.6039 62.7074 62.7852 62.2748 62.7852 61.7722C62.7852 61.2696 62.6039 60.837 62.2414 60.4744L21.7018 19.9349C21.3558 19.5888 20.9232 19.4158 20.4041 19.4158C19.885 19.4158 19.4442 19.5888 19.0816 19.9349C18.7355 20.2974 18.5625 20.7383 18.5625 21.2574C18.5625 21.7765 18.7355 22.2008 19.0816 22.5304L59.6459 63.0699C60.0084 63.4325 60.4451 63.6138 60.956 63.6138ZM48.6705 60.7216C49.2968 60.7216 49.8447 60.5568 50.3144 60.2272C50.784 59.8976 51.126 59.395 51.3402 58.7194L24.3715 31.7754C23.6299 32.6158 23.2592 33.86 23.2592 35.508V44.4069C23.2592 46.1702 23.6753 47.4845 24.5075 48.3496C25.3397 49.2148 26.588 49.6474 28.2524 49.6474H34.8772C35.0914 49.6474 35.2809 49.7216 35.4457 49.8699L45.4323 59.189C46.0091 59.7328 46.5488 60.1242 47.0514 60.3632C47.554 60.6021 48.0938 60.7216 48.6705 60.7216Z" fill="#161819" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const BrightcovePlayerAutoplay = t0 => {
  const $ = _c(19);
  const {
    videoId,
    accountId: t1,
    playerId: t2,
    videoPlayerAspectRatio: t3,
    isMuted: t4,
    width
  } = t0;
  const accountId = t1 === undefined ? "1634697872" : t1;
  const playerId = t2 === undefined ? "AFPbTgXrMJ" : t2;
  const videoPlayerAspectRatio = t3 === undefined ? "16 / 9" : t3;
  const isMuted = t4 === undefined ? true : t4;
  const [showUnmuteButton, setShowUnmuteButton] = useState(isMuted);
  let t5;
  if ($[0] !== showUnmuteButton) {
    t5 = {
      autoplay: true,
      muted: showUnmuteButton
    };
    $[0] = showUnmuteButton;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== videoPlayerAspectRatio || $[3] !== width) {
    t6 = t7 => {
      const {
        ref
      } = t7;
      Object.assign(ref.el_.style, {
        borderRadius: "30px",
        width: width ? `${width}px` : "100%",
        aspectRatio: videoPlayerAspectRatio,
        height: "auto"
      });
      Object.assign(ref.el_.parentElement.style, {
        width: "100%"
      });
    };
    $[2] = videoPlayerAspectRatio;
    $[3] = width;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== accountId || $[6] !== playerId || $[7] !== t5 || $[8] !== t6 || $[9] !== videoId) {
    t7 = <ReactPlayerLoader accountId={accountId} playerId={playerId} videoId={videoId} options={t5} onSuccess={t6} />;
    $[5] = accountId;
    $[6] = playerId;
    $[7] = t5;
    $[8] = t6;
    $[9] = videoId;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = !showUnmuteButton;
  let t9;
  if ($[11] !== t8) {
    t9 = cn("absolute top-0 left-0 size-full", {
      hidden: t8
    });
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <button className={cn("absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2")} onClick={() => {
      setShowUnmuteButton(false);
    }}><UnmuteIcon /></button>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t9) {
    t11 = <div className={t9}>{t10}</div>;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t7) {
    t12 = <div className="relative size-full">{t7}{t11}</div>;
    $[16] = t11;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};
export const BrightcovePlayerManualPlay = t0 => {
  const $ = _c(9);
  const {
    videoId,
    accountId: t1,
    playerId: t2,
    videoPlayerAspectRatio: t3,
    width
  } = t0;
  const accountId = t1 === undefined ? "1634697872" : t1;
  const playerId = t2 === undefined ? "adCNPdiKU" : t2;
  const videoPlayerAspectRatio = t3 === undefined ? "16 / 9" : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      autoplay: false
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== videoPlayerAspectRatio || $[2] !== width) {
    t5 = t6 => {
      const {
        ref
      } = t6;
      Object.assign(ref.el_.style, {
        borderRadius: "30px",
        width: width ? `${width}px` : "100%",
        aspectRatio: videoPlayerAspectRatio,
        height: "auto"
      });
      Object.assign(ref.el_.parentElement.style, {
        width: "100%"
      });
    };
    $[1] = videoPlayerAspectRatio;
    $[2] = width;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== accountId || $[5] !== playerId || $[6] !== t5 || $[7] !== videoId) {
    t6 = <ReactPlayerLoader accountId={accountId} playerId={playerId} videoId={videoId} options={t4} onSuccess={t5} />;
    $[4] = accountId;
    $[5] = playerId;
    $[6] = t5;
    $[7] = videoId;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export const BrightcovePlayer = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = props?.autoplay ? <BrightcovePlayerAutoplay {...props} /> : <BrightcovePlayerManualPlay {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};